var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "contents" }, [
    _vm.pricing
      ? _c(
          "div",
          { staticClass: "pricing-593c0a", class: { simple: _vm.isSimple } },
          [
            _vm.showOriginalPrice
              ? _c("div", { staticClass: "original-price" }, [
                  !_vm.isSimple
                    ? _c("span", { staticClass: "prepend" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "88401.DetailpageFromToPrice_RegularPriceLabel"
                            )
                          )
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("span", { staticClass: "price" }, [
                    _vm._v(_vm._s(_vm.pricing.original.price.toString())),
                  ]),
                  _vm._v(" "),
                  !_vm.isSimple
                    ? _c(
                        "span",
                        {
                          staticClass: "info pricing-info-icon",
                          on: {
                            click: function ($event) {
                              _vm.openPriceModal(
                                $event,
                                _vm.pricing.original.price.toString()
                              )
                            },
                          },
                        },
                        [_c("i", { staticClass: "sd2-icons info-outline" })]
                      )
                    : _vm._e(),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.pricing.hasPriceLabelOrCurrentPrice()
              ? _c("span", {
                  staticClass: "current-price",
                  class: {
                    "current-price--superseded": _vm.hasPromoCodeToShow,
                  },
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.hasPromoCodeToShow && _vm.pricing.hasCurrent()
                        ? _vm.pricing.current.price.toString()
                        : _vm.pricing.priceLabelOrCurrentPrice
                    ),
                  },
                })
              : _vm._e(),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.hasNote
      ? _c(
          "div",
          {
            staticClass: "pricing-593c0a-label",
            class: { positive: this.note.type === "positive" },
          },
          [
            this.note.type === "positive"
              ? _c("i", { staticClass: "sd2-icons checkmark" })
              : _vm._e(),
            _vm._v("\n    " + _vm._s(this.note.text) + "\n  "),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.hasPromoCodeToShow
      ? _c("div", { staticClass: "promo-price-label-wrapper" }, [
          _c("div", { staticClass: "promo-price-label" }, [
            _c("span", { staticClass: "promo-price-label__text" }, [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "10091850.Detailpage_Multicart_Label_Text_Promo_Code_Price"
                  )
                )
              ),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "promo-price-label__price" }, [
              _vm._v(_vm._s(_vm.promoCodePriceLabel)),
            ]),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }